export enum BaseAgreeType {
  TypeService,
  TypeActivity,
}
